import { Component } from '@angular/core';
import { BaseComponent } from "@wms/components";
import { ApiIssuesComponent } from "@wms/app/bottom-left-menu/components/issues/api-issues/api-issues.component";
import {removeResizableClass} from "@wms/core";
import {IssuesService} from "@wms/app/bottom-left-menu/components/issues/issues.service";
import {CodeInspectComponent, CodeInspectService} from "@wms/app/bottom-left-menu";
import {NgClass, NgIf} from "@angular/common";
import {ApisService} from "@wms/services";
import {setLocalStorageItem } from 'projects/core/src/utils/studio-user-preferences';

@Component({
  selector: 'wms-issues',
  templateUrl: './issues.component.html',
  styleUrls: ['./issues.component.less'],
  imports: [ApiIssuesComponent, CodeInspectComponent, NgIf, NgClass],
  standalone: true
})
export class IssuesComponent extends BaseComponent {

  constructor(protected issuesService: IssuesService, protected codeInspectService: CodeInspectService,
              private apiService: ApisService) {
    super();
  }


  closeIssues() {
    this.issuesService.isFirstChecked = true;
    if(!this.codeInspectService.isPollingDone()){
        this.codeInspectService.pollStatus.showMessage = false;
        this.codeInspectService.storeJobData();
    }
    setLocalStorageItem('issues-intro-done', 'true');
    this.issuesService.isEnabled = false;
    this.apiService.reimportedServiceId = '';
    removeResizableClass('wm-studio-content-issues');
  }

  refreshInspect() {
    if(this.issuesService.activeTab === 'inspect') {
      this.eventManager.emitRefreshInspect();
    }
    if(this.issuesService.activeTab === 'api-issues') {
      this.eventManager.emitRefreshAPIIssues();
    }
  }
}
